import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Typography } from 'common/components/Typography';
import { GroupListItem } from 'user/components/GroupListItem/GroupListItem';
import { TGroupListItem, TGroupPermission } from 'user/types';
import { isGroupSelected } from 'user/utils';

interface IProps {
    checkGroupPermission?: TGroupPermission;
    disabledGroupIds?: string[];
    selectedGroups: TGroupListItem[];
    groups: TGroupListItem[];
    onAddGroup?(selectedGroup: TGroupListItem): void;
    onRemoveGroup?(selectedGroup: TGroupListItem): void;
}

export const GroupAddList = ({
    checkGroupPermission,
    disabledGroupIds,
    selectedGroups,
    groups,
    onAddGroup,
    onRemoveGroup,
}: IProps) => {
    const { t: translate } = useTranslation();

    const handleSelectGroup = (group: TGroupListItem, isAdded: boolean) => {
        isAdded ? onRemoveGroup?.(group) : onAddGroup?.(group);
    };

    return (
        <>
            {!groups.length ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 7,
                    }}
                >
                    <Typography>{translate('noOptionsText.groups')}</Typography>
                </Box>
            ) : (
                groups.filter(Boolean).map((group) => {
                    const isLocked = !!disabledGroupIds?.includes(group.id);
                    const isSelected =
                        isLocked || isGroupSelected(selectedGroups, group);
                    const { permissions } = group;
                    const permissionsObj = JSON.parse(permissions || '{}');

                    let isDisabled = isLocked;

                    // Check if the user has the permission to add this group
                    if (
                        (!!checkGroupPermission?.canAddParticipants &&
                            !permissionsObj.canAddParticipants) ||
                        (!!checkGroupPermission?.canAddManagers &&
                            !permissionsObj.canAddManagers)
                    ) {
                        isDisabled = true;
                    }

                    return (
                        <GroupListItem
                            addButton
                            added={isSelected}
                            disabled={isDisabled}
                            group={group}
                            key={group.id}
                            px={2}
                            selected={isSelected}
                            onClick={() => handleSelectGroup(group, isSelected)}
                        />
                    );
                })
            )}
        </>
    );
};
